import { usePermissionsCtx } from 'client/contexts/Permissions';
import { useOptimizelyFeature } from 'client/hooks/useOptimizelyFeature';
import { PermissionLabel } from 'client/generated/graphql';

const useHasPermission = () => {
  const [MUMS_FEATURE_FLAG] = useOptimizelyFeature('mums');
  const { permissionsForShow } = usePermissionsCtx();

  const hasPermission = ({
    permissionsToCheck,
    allRequired,
  }: {
    permissionsToCheck: PermissionLabel[];
    allRequired: boolean;
  }) => {
    if (MUMS_FEATURE_FLAG) {
      // If a user is flagged into MUMS and has
      // EVERY permission in the permissionsToCheck
      // array is present on the permissionsForShow
      // return true, otherwise return false
      if (allRequired) {
        return permissionsToCheck?.every(permission =>
          permissionsForShow?.includes(permission)
        );
      }

      // If a user is flagged into MUMS and has
      // AT LEAST ONE permission in the permissionsToCheck
      // array is present on the permissionsForShow
      // return true, otherwise return false
      return permissionsToCheck?.some(permission =>
        permissionsForShow?.includes(permission)
      );
    }

    // If a user is not flagged into MUMS, they
    // have permissions for everything; this
    // powers the default Anchor experience
    return true;
  };

  return { hasPermission };
};

export { useHasPermission };
